import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import MetaData from "../../components/layout/MetaData";
import { useMyQuotesQuery } from "../../redux/api/quoteApi";

/**
 * 用户报价历史页面。
 */
const MyQuotes = () => {
  const { data, isLoading, error } = useMyQuotesQuery();

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message || "Failed to load quotes");
    }
  }, [error]);

  /**
   * 构建报价表格数据。
   * @returns {Object} MDBDataTable 数据
   */
  const setQuotes = () => {
    const quotes = {
      columns: [
        { label: "Quote No", field: "quoteNo", sort: "asc" },
        { label: "Type", field: "quoteType", sort: "asc" },
        { label: "Status", field: "status", sort: "asc" },
        { label: "Total", field: "total", sort: "asc" },
        { label: "Created At", field: "createdAt", sort: "asc" },
        { label: "Order", field: "order", sort: "asc" },
      ],
      rows: [],
    };

    data?.quotes?.forEach((quote) => {
      quotes.rows.push({
        quoteNo: quote?.quoteNo,
        quoteType: quote?.quoteSnapshot?.quoteTypeLabel || quote?.quoteType,
        status: quote?.status,
        total: `$${Number(quote?.pricing?.totalAmount || 0).toFixed(2)}`,
        createdAt: new Date(quote?.createdAt).toLocaleString("en-US"),
        order: quote?.orderId?._id ? (
          <Link className="text-blue-600" to={`/me/order/${quote.orderId._id}`}>
            View
          </Link>
        ) : (
          "-"
        ),
      });
    });

    return quotes;
  };

  if (isLoading) return <Loader />;

  return (
    <div className="container mx-auto px-4 py-4">
      <MetaData title="My Quotes" />
      <h1 className="text-2xl font-semibold my-5">
        {data?.quotes?.length || 0} Quotes
      </h1>
      <MDBDataTable data={setQuotes()} className="px-3" bordered striped hover />
    </div>
  );
};

export default MyQuotes;
